var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg15Account(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8331 41.4525C34.7071 41.4525 31.0572 43.6424 29.1211 47.1336C31.692 49.5458 35.0881 50.974 38.8331 50.974C42.578 50.974 45.9742 49.5458 48.5451 47.1336C46.609 43.6424 42.9591 41.4525 38.8331 41.4525Z",
    fill: "#26B89A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7676 33.5179C46.7676 29.1432 43.2078 25.5834 38.833 25.5834C34.4582 25.5834 30.8984 29.1432 30.8984 33.5179C30.8984 37.8927 34.4582 41.4525 38.833 41.4525C43.2078 41.4525 46.7676 37.8927 46.7676 33.5179Z",
    fill: "#26B89A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0152 25.7354C60.4133 27.9686 61.4175 30.394 62.011 32.9695L65.9167 33.9195V42.7468L62.011 43.6968C61.4175 46.2723 60.4133 48.6977 59.0152 50.9309L61.0286 54.2891L54.7893 60.5285L51.4311 58.5151C49.1979 59.9131 46.7724 60.9173 44.197 61.5108L43.2469 65.4165H34.4197L33.4696 61.5108C30.8942 60.9173 28.4688 59.9131 26.2355 58.5151L22.8774 60.5285L16.638 54.2891L18.6514 50.9309C17.2534 48.6977 16.2491 46.2723 15.6557 43.6968L11.75 42.7468V33.9195L15.6557 32.9695C16.2491 30.394 17.2534 27.9686 18.6514 25.7354L16.638 22.3772L22.8774 16.1378L26.2355 18.1512C28.4688 16.7532 30.8942 15.749 33.4696 15.1555L34.4197 11.2498H43.2469L44.197 15.1555C46.7724 15.749 49.1979 16.7532 51.4311 18.1512L54.7893 16.1378L61.0286 22.3772L59.0152 25.7354ZM38.8334 57.2094C49.2585 57.2094 57.7096 48.7582 57.7096 38.3331C57.7096 27.9081 49.2585 19.4569 38.8334 19.4569C28.4083 19.4569 19.9571 27.9081 19.9571 38.3331C19.9571 48.7582 28.4083 57.2094 38.8334 57.2094Z",
    fill: "#20493C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg15Account);
export default __webpack_public_path__ + "static/media/15_account.b0f139e57b169b809b85c7356e16431c.svg";
export { ForwardRef as ReactComponent };